<template>
  <v-container>
    <v-layout justify-center>
      <v-flex xs8>
        <v-card>
          <v-layout justify-center>
            <v-img :src="require('../assets/logo_small.jpg')" max-width="560px" />
          </v-layout>

          <v-container>
            <v-layout column>
              <v-layout>
                <iframe
                width="100%"
                height="450"
                scrolling="no"
                frameborder="no"
                allow="autoplay"
                src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/users/4886974&color=%23ff5500&auto_play=false&hide_related=false&show_comments=false&show_user=false&show_reposts=true&show_teaser=false&show_artwork=false&show_repost=true">
                </iframe>
              </v-layout>

              <Social />
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Social from './Social.vue';

export default {
  name: 'Home',
  components: {
    Social,
  },
};
</script>
